// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg {
  border-radius: 12px;
  border: 1px solid var(--Grey-10, #f3f3f3);
  background: var(--White, #fdfdfd);
  /* XS */
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.bg-green {
  border-radius: 8px;
  background: #e5fff6;
}

@media screen and (max-width: 650px) {
  .pad {
    padding-top: 60px !important;
    height: 100vh !important;
    background-color: white !important;
  }
  .mobile-container {
    width: 100% !important;
    height: 100% !important;
    padding: 24px !important;
    gap: 22px !important;
    border: none !important;
  }
  .mobile-head {
    color: var(--Black, #101010);
    /* Heading/24 */
    font-family: "General Sans";
    font-size: 24px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: 135% !important;
  }
  .mobile-text {
    color: var(--Grey-70, #878787);
    /* Label/14 */
    font-family: "General Sans";
    font-size: 14px !important;
    font-style: normal;
    font-weight: 500 !important;
    line-height: 115% !important;
  }
  .infocard {
    gap: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/request-event/style.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yCAAA;EACA,iCAAA;EAEA,OAAA;EACA,kDAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE;IACE,4BAAA;IACA,wBAAA;IACA,kCAAA;EAAF;EAEA;IACE,sBAAA;IACA,uBAAA;IACA,wBAAA;IACA,oBAAA;IACA,uBAAA;EAAF;EAGA;IACE,4BAAA;IACA,eAAA;IACA,2BAAA;IACA,0BAAA;IACA,kBAAA;IACA,2BAAA;IACA,4BAAA;EADF;EAIA;IACE,8BAAA;IACA,aAAA;IACA,2BAAA;IACA,0BAAA;IACA,kBAAA;IACA,2BAAA;IACA,4BAAA;EAFF;EAKA;IACE,oBAAA;EAHF;AACF","sourcesContent":[".bg {\n  border-radius: 12px;\n  border: 1px solid var(--Grey-10, #f3f3f3);\n  background: var(--White, #fdfdfd);\n\n  /* XS */\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.bg-green {\n  border-radius: 8px;\n  background: #e5fff6;\n}\n\n@media screen and (max-width: 650px) {\n  .pad {\n    padding-top: 60px !important;\n    height: 100vh !important;\n    background-color: white !important;\n  }\n  .mobile-container {\n    width: 100% !important;\n    height: 100% !important;\n    padding: 24px !important;\n    gap: 22px !important;\n    border: none !important;\n  }\n\n  .mobile-head {\n    color: var(--Black, #101010);\n    /* Heading/24 */\n    font-family: \"General Sans\";\n    font-size: 24px !important;\n    font-style: normal;\n    font-weight: 600 !important;\n    line-height: 135% !important;\n  }\n\n  .mobile-text {\n    color: var(--Grey-70, #878787);\n    /* Label/14 */\n    font-family: \"General Sans\";\n    font-size: 14px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: 115% !important;\n  }\n\n  .infocard{\n    gap:12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
